import { GenericElement } from "../Elements/GenericElement";
import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { OptionData, Options } from "select2";
import { checkAndDestroySelect2, globalMatcher, globalTemplateResult } from "../Tools/GlobalMethods";
import { FiltersController } from "../Tools/FiltersController";

export class BathroomTypeFilter implements IFilter {

    id: string;
    name?: string | null;
    type: string;
    bathroomElements: GenericElement[] = [];
    parentGroup: FilterGroup;
    controller: FiltersController;
    static searchQuery: string;

    constructor(bathroomElements: GenericElement[], parentGroup: FilterGroup) {
        this.id = 'bathroomType';
        this.name = 'Collections de salle de bains';
        this.type = 'bathroomType';

        this.bathroomElements = bathroomElements;
        this.parentGroup = parentGroup;
        this.controller = new FiltersController();
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;max-width: 380px;width: 100%;">
            <span>${this.name}</span>
            <select id="bathroomTypeSelect" style="width: 100%" title="${this.name}"></select>
        </div>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            checkAndDestroySelect2('#bathroomTypeSelect');
            $('#bathroomTypeSelect').select2({
                placeholder: {
                    id: '-2',
                    text: 'Choisissez une collection'
                },
                data: [
                    {
                        id: '-2',
                        text: 'Choisissez une collection',
                    } as OptionData,
                    ...this.bathroomElements.map((element) => {
                        return {
                            id: element.id || '-1',
                            text: element.name,
                            title: this.name,
                            selected: element.name === FilterGroup.filters.bathroomElement?.name
                        } as OptionData;
                    }),
                ],
                matcher: globalMatcher,
                templateResult: globalTemplateResult,
                dropdownAutoWidth: true,
                selectionCssClass: 'select-control',

            } as unknown as Options);
            $('#bathroomTypeSelect').on('change.select2', () => {
                let selectedValue = $('#bathroomTypeSelect').val() as string;
                if (selectedValue === '-1') {
                    FilterGroup.filters.bathroomElement = null;
                } else {
                    FilterGroup.filters.bathroomElement = this.bathroomElements.find((element) => element.id === selectedValue) || null;
                }
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            });

        });

        return html;
    }

    // Done
    generateStringFilter(): string {
        if (FilterGroup.filters.bathroomElement && FilterGroup.filters.bathroomElement.id) {
            let stringFilters = "";

            switch (FilterGroup.filters.bathroomElement.type) {
                case 'ObjectType':
                    stringFilters += '&descending=objectType&q.objectType.in=' + FilterGroup.filters.bathroomElement.id;
                    break;
                case 'CollectionType':
                    stringFilters += '&q.manufacturer_collection.eq=' + FilterGroup.filters.bathroomElement.id;
                    break;
            }
            if (FilterGroup.filters.bathroomElement.name.indexOf('Lapeyre Formeo') !== -1) {
                stringFilters += '&sort=objectType,dimensions.length,dimensions.height,dimensions.width';
            }
            else {
                if (FilterGroup.filters.bathroomElement.type === 'CollectionType') {
                    stringFilters += '&sort=name';
                }
            }
            return(stringFilters)
        }

        return('&descending=objectType&q.objectType.eq=5bc06cbebe6c755c1fb2d5e3');
    }

    destroy(): void {
        $('#bathroomTypeSelect').off('change.select2');
        checkAndDestroySelect2('#bathroomTypeSelect');
        this.controller.destroy();
    }
}